import intersection from 'lodash/intersection';

export const arrayContainsArray: <T>(input: T[], searched: T[]) => boolean = (input, searched) => {
  return intersection(input, searched).length === searched.length;
};
